import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

/**
 * Determines if an employee's salary is currently active based on employment dates.
 * 
 * For WintSalary companies: Active if employment has started and not ended (or end date is future/today)
 * For legacy companies: Uses the isActive flag from backend
 * 
 * @param employeeItem - Employee item from the list
 * @param isWintSalaryCompany - Whether the company uses WintSalary system
 * @returns true if salary is currently active
 */
export const isEmployeeSalaryActive = (
  employeeItem: WintSuperkollAPIModel.EmployeeItem,
  isWintSalaryCompany: boolean
): boolean => {
  if (isWintSalaryCompany) {
    // For WintSalary: Check employment dates
    return !!(
      employeeItem.salaryInfo?.employmentStartDate &&
      (!employeeItem.salaryInfo?.employmentEndDate ||
        new Date(employeeItem.salaryInfo.employmentEndDate) >= new Date())
    );
  } else {
    // For legacy: Use backend flag
    return employeeItem.salaryInfo?.isActive ?? false;
  }
};

